// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bTDW","inner":"Footer_inner__2Nzub","nextIcon":"Footer_nextIcon__ljCVT","innerLeft":"Footer_innerLeft__1nKuj"};